<template>
  <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
    <div class="card mb-4">
      <div class="card-header">
        <h3 class="mb-0" v-text="title"></h3>
      </div>

      <div class="card-body">
        <h5 class="text-center info-text" v-text="subtitle"></h5>

        <campaign-select v-model="formData.campaign" v-validate="modelValidations.campaign" name="campaign" />
        <small v-show="campaign.invalid" class="text-danger">
          {{ getError('campaign') }}
        </small>

        <label class="control-label w-100">
          <span>Seleccione Tipo</span>
        </label>
        <el-select v-model="formData.type" v-validate="modelValidations.type" name="type">
          <el-option v-for="option in options" :key="option.id" :label="option.label" :value="option.id"></el-option>
        </el-select>
        <small v-show="type.invalid" class="text-danger">
          {{ getError('type') }}
        </small>

        <distributor-select
          v-if="showDistributorFrom"
          ref="DistributorFromSelect"
          v-model="formData.distributorFrom"
          v-validate="'required_if:${showDistributorFrom}'"
          name="distributorFrom"
          label="Seleccione Distribuidor de Salida"
        />
        <small v-show="distributorFrom.invalid" class="text-danger">
          {{ getError('distributorFrom') }}
        </small>

        <distributor-select
          v-if="showDistributorTo"
          ref="DistributorToSelect"
          v-model="formData.distributorTo"
          v-validate="'required_if:${showDistributorFrom}'"
          name="distributorTo"
          label="Seleccione Distribuidor de Entrada"
        />
        <small v-show="distributorTo.invalid" class="text-danger">
          {{ getError('distributorTo') }}
        </small>

        <producer-select
          v-if="showDistributorTo"
          ref="producerSelect"
          v-model="formData.producer"
          v-validate="'required_if:${showDistributorTo}'"
          name="producer"
          :distributor="formData.distributorTo"
          :disabled="formData.distributorTo"
        />
        <small v-show="producer.invalid" class="text-danger">
          {{ getError('producer') }}
        </small>

        <div v-if="formData.type !== ADJUST" class="form-group">
          <label class="control-label w-100">
            <span> Numero de Remito </span>
          </label>

          <el-input
            v-model="formData.code"
            v-validate="modelValidations.code"
            name="code"
            pattern="\d{4}-\d{8}"
            maxlength="13"
            placeholder="####-########"
          />

          <small class="text-muted d-block"> Formato de código: 9999-99999999 </small>

          <small class="text-danger">
            {{ getError('code') }}
          </small>
        </div>

        <div v-if="showAdjust" class="form-group">
          <label class="control-label w-100">
            <span> Razón de Ajuste </span>
          </label>

          <el-input
            v-model="formData.comment"
            v-validate="modelValidations.comment"
            name="comment"
            placeholder="Razón del Ajuste"
          />

          <small class="text-danger">
            {{ getError('comment') }}
          </small>
        </div>

        <div class="text-right">
          <base-button type="primary" @click="onSelect">Seleccionar</base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import DistributorSelect from '@/components/ModelSelects/DistributorSelect';
import ProducerSelect from '@/components/ModelSelects/ProducerSelect';
import { Select, Option } from 'element-ui';
import { DEVOLUTION, LOAD_DISTRIBUTOR, ADJUST, CODE_MASK_REGEX } from '@/util/constants/deliveryNotes';
import { mapFields } from 'vee-validate';

export default {
  name: 'PreSelectDeliveryNotes',
  components: {
    CampaignSelect,
    DistributorSelect,
    ProducerSelect,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    title: {
      type: String,
      default: 'Seleccione campaña, distribuidores e ingrese codigo de remito',
    },

    subtitle: {
      type: String,
      required: true,
    },

    deliveryNote: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      formData: {
        type: this.deliveryNote ? this.deliveryNote.type : null,
        code: this.deliveryNote ? this.deliveryNote.code : '',
        user: this.$auth.user().data,
        distributorTo: this.deliveryNote ? this.deliveryNote.distributorTo.id : null,
        distributorFrom: this.deliveryNote ? this.deliveryNote.distributorFrom.id : null,
        producer: null,
        campaign: this.deliveryNote ? this.deliveryNote.campaign.id : null,
        comment: this.deliveryNote ? this.deliveryNote.comment : null,
      },

      LOAD_DISTRIBUTOR,
      DEVOLUTION,
      ADJUST,

      options: [],

      validated: false,
      modelValidations: {
        type: {
          required: true,
        },

        code: {
          required: false,
          regex: CODE_MASK_REGEX,
        },

        campaign: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['type', 'code', 'user', 'distributorTo', 'distributorFrom', 'campaign', 'producer', 'comment']),

    showDistributorFrom() {
      return this.formData.type !== this.LOAD_DISTRIBUTOR && this.formData.type !== this.ADJUST;
    },

    showDistributorTo() {
      return this.formData.type !== this.DEVOLUTION;
    },

    showAdjust() {
      return this.formData.type === this.ADJUST;
    },
  },

  watch: {
    'formData.type'() {
      if (this.$refs.distributorFromSelect) {
        this.$refs.distributorFromSelect.clearSelection();
        this.formData.distributorFrom = null;
      }
      if (this.$refs.distributorToSelect) {
        this.$refs.distributorToSelect.clearSelection();
        this.formData.distributorTo = null;
      }
      if (this.$refs.producerSelect) {
        this.$refs.producerSelect.clearSelection();
        this.formData.producer = null;
      }
    },

    'formData.distributorTo'() {
      this.$refs.producerSelect.clearSelection();
      this.formData.producer = null;
    },
  },

  mounted() {
    this.fetchDeliveryNoteTypes();
  },

  methods: {
    fetchDeliveryNoteTypes() {
      this.$services
        .resource('delivery_note_types')
        .get()
        .then((res) => {
          this.options = res.data.data;
        });
    },

    onSelect() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$services
            .resource('delivery_notes')
            .findByCode(this.formData.code)
            .then(() => {
              this.errors.add({
                field: 'code',
                msg: 'El codigo ingresado ya existe',
              });
            })
            .catch(() => {
              this.$emit('selected', {
                ...this.formData,
                distributorFrom: this.formData.type !== LOAD_DISTRIBUTOR ? this.formData.distributorFrom : null,
                distributorTo: this.formData.type !== DEVOLUTION ? this.formData.distributorTo : null,
              });
            });
        }
      });
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
  margin-bottom: 24px;
}
</style>
